import { useApi } from "auth/useApi3"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import React, { useContext, useEffect } from "react"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { Box, Button, Container, Grid, Typography, useTheme } from "@mui/material"
import { NavLink } from "react-router-dom"
import { allRoutes } from "generated/routes"
import { SkeletonCard } from "components/skeleton/SkeletonCard"
import { hasRole } from "auth/hasRole"
import { AppContext } from "components/AppContextProvider"
import { allRoles } from "generated/roles"
import PaperBox from "components/PaperBox"
import TemplateCard from "./TemplateCard"
import { ListReportTemplatesProps, ReportTemplate, ReportTypeEnum } from "../interfaces/reports.interfaces"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/pro-solid-svg-icons"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { StyledIconBox } from "./reports.styled"
import { useTranslation } from "react-i18next"
import { StyledFontAwesomeIconForButton } from "shared/styled/General"

const skeletonRows = [1, 2, 3, 4, 5, 6]

const ListReportTemplates = ({ reportType }: ListReportTemplatesProps) => {
  const { t } = useTranslation()
  const appContext = useContext(AppContext)
  const [templatesResult, templateApi] = useApi() as [IApiResult, IApiFunc]
  const loadingContext = useContext(GlobalLoaderContext)
  const isAdmin = hasRole(appContext.appUser, allRoles.ReportsAdmin)
  const theme = useTheme()

  useEffect(() => {
    const url = `${apiEndpoints.reporting.getreporttemplates}?reportType=${reportType}`
    templateApi.get(url)
  }, [])

  useEffect(() => {
    loadingContext.setLoading(() => templatesResult.status === 1)
  }, [])

  const reportTemplateAdd = reportType === ReportTypeEnum.User
    ? allRoutes.ReportsUserreportsReporttemplatesAdd()
    : allRoutes.ReportsVehiclereportsReporttemplatesAdd()

  return (
    <Container>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" mb={5}>
        <Typography mb={{ xs: 2, sm: 0 }} variant="h1">{t("global.report_templates", "Report templates")}</Typography>
        {isAdmin && (
          <Button
            component={NavLink}
            to={reportTemplateAdd}
            color="primary"
            variant="contained"
          >
            {t("dashboard.create_new_report", "Create new report")}
            <StyledFontAwesomeIconForButton icon={faPlus} />
          </Button>
        )}
      </Grid>
      <Grid container direction="column">
        {templatesResult.status === 2 ?
          templatesResult?.data?.length > 0 ? templatesResult?.data?.map((result: ReportTemplate, index: number) => (
            <TemplateCard
              key={result.id}
              data={result}
              reportType={reportType}
              index={index}
              totalCards={templatesResult.data.length}
            />
          )) : (
            <PaperBox>
              <Box>{t("reports.there_are_no_report_templates_to_display", "There are no report templates to display")}</Box>
            </PaperBox>
          )
          : skeletonRows.map((index) => (
            <Grid key={index} item xs={12}>
              <SkeletonCard padding="13px 15px" />
            </Grid>
          )
          )}
      </Grid>
    </Container>
  )
}

export default ListReportTemplates